"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 16,
  width = size,
  height = size,
  fill,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1201 8.78C14.151 8.53 14.1716 8.27 14.1716 8C14.1716 7.73 14.151 7.47 14.1099 7.22L15.8482 5.9C16.0025 5.78 16.0436 5.56 15.951 5.39L14.3053 2.62C14.2024 2.44 13.9864 2.38 13.8013 2.44L11.7544 3.24C11.3224 2.92 10.8698 2.66 10.3658 2.46L10.0572 0.34C10.0263 0.14 9.85147 0 9.64575 0H6.35425C6.14853 0 5.98395 0.14 5.95309 0.34L5.64452 2.46C5.1405 2.66 4.67764 2.93 4.25591 3.24L2.20901 2.44C2.02386 2.37 1.80785 2.44 1.705 2.62L0.0592423 5.39C-0.0436173 5.57 -0.00247343 5.78 0.162102 5.9L1.90043 7.22C1.85928 7.47 1.82843 7.74 1.82843 8C1.82843 8.26 1.849 8.53 1.89014 8.78L0.151816 10.1C-0.00247345 10.22 -0.0436173 10.44 0.0489563 10.61L1.69471 13.38C1.79757 13.56 2.01357 13.62 2.19872 13.56L4.24563 12.76C4.67764 13.08 5.13022 13.34 5.63423 13.54L5.94281 15.66C5.98395 15.86 6.14853 16 6.35425 16H9.64575C9.85147 16 10.0263 15.86 10.0469 15.66L10.3555 13.54C10.8595 13.34 11.3224 13.07 11.7441 12.76L13.791 13.56C13.9761 13.63 14.1921 13.56 14.295 13.38L15.9408 10.61C16.0436 10.43 16.0025 10.22 15.8379 10.1L14.1201 8.78ZM8.00009 11C6.30291 11 4.91431 9.65 4.91431 8C4.91431 6.35 6.30291 5 8.00009 5C9.69728 5 11.0859 6.35 11.0859 8C11.0859 9.65 9.69728 11 8.00009 11Z",
  fill: fill ? fill : '#121213'
}));

exports.default = _default;